export default __webpack_public_path__ + "static/media/017-turtle.12065a90.svg";